const formField = $('.apo-form input, .apo-form textarea');

formField.each(function () {
  const formField = $(this).closest('.form-field');
  const errorMessageMissing = formField.find('.error-message--missing');
  const errorMessageInvalid = formField.find('.error-message--invalid');

  $(this).blur(function () {
    showError(this, formField, errorMessageMissing, errorMessageInvalid);
  });
  $(this).change(function () {
    showError(this, formField, errorMessageMissing, errorMessageInvalid);
  });
  $(this).keyup(function () {
    showError(this, formField, errorMessageMissing, errorMessageInvalid);
  });
});

export function showError(element, formField, errorMessageMissing, errorMessageInvalid) {
  if (element.validity.valueMissing) {
    formField.addClass('error');
    if (errorMessageMissing) errorMessageMissing.addClass('active');
    if (errorMessageInvalid) errorMessageInvalid.removeClass('active');
  } else if (element.validity.typeMismatch) {
    formField.addClass('error');
    if (errorMessageMissing) errorMessageMissing.removeClass('active');
    if (errorMessageInvalid) errorMessageInvalid.addClass('active');
  } else if (element.validity.patternMismatch) {
    if(element.value){
      formField.addClass('error');
      if (errorMessageMissing) errorMessageMissing.removeClass('active');
      if (errorMessageInvalid) errorMessageInvalid.addClass('active');
    }
  } else if (element.type=='textarea' && element.validity.tooLong){
    formField.addClass('error');
    if (errorMessageMissing) errorMessageMissing.removeClass('active');
    if (errorMessageInvalid) errorMessageInvalid.addClass('active');
  } else {
    formField.removeClass('error');
    if (errorMessageMissing) errorMessageMissing.removeClass('active');
    if (errorMessageInvalid) errorMessageInvalid.removeClass('active');
  }
}
